import { ComponentPropsWithoutRef } from 'react';

export const DownloadIconV2 = ({
  ...props
}: ComponentPropsWithoutRef<'svg'>) => {
  return (
    <svg {...props} viewBox="0 0 31 30" fill="none">
      <path
        d="M27.167 16.667V25c0 .917-.75 1.667-1.667 1.667h-20c-.917 0-1.667-.75-1.667-1.667v-8.333c0-.917-.75-1.667-1.666-1.667C1.25 15 .5 15.75.5 16.667v10C.5 28.5 2 30 3.833 30h23.334C29 30 30.5 28.5 30.5 26.667v-10c0-.917-.75-1.667-1.667-1.667-.916 0-1.666.75-1.666 1.667Zm-10-.55 3.133-3.134a1.662 1.662 0 0 1 2.35 2.35l-5.983 5.984a1.66 1.66 0 0 1-2.35 0l-5.984-5.984a1.662 1.662 0 1 1 2.35-2.35l3.15 3.134V1.667C13.833.75 14.583 0 15.5 0s1.667.75 1.667 1.667v14.45Z"
        fill="#000000"
      />
    </svg>
  );
};
